if(!customElements.get('product-before-after')) {
  class ComponentProductBeforeAfter extends HTMLElement {
    constructor() {
      super();

      var sliders = this.querySelectorAll(".slider.before-after-slider");

      if(sliders.length == 0)
        this.style.display = "none";

      sliders.forEach(function(slider){
        var rightImg = slider.closest(".before-after-snipped").querySelector(".right-img");
        slider.addEventListener('slider', function (e) {
          var percent = (e.detail.toFixed(2)) + "%";
          rightImg.style.clipPath = `polygon(${percent} 0, 100% 0, 100% 100%, ${percent} 100%)`;
        }, false); 
      });
      
    }
 
  }
   
  customElements.define('product-before-after', ComponentProductBeforeAfter);
}
